import { SearchTerm } from "./SearchTerm";

const AccessGroupSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "agName",
        translationKey: "name"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site"
    },
    {
        heading: "Access Area",
        accessor: "area",
        searchOnName: "area.areaName",
        translationKey: "accessArea"
    },
    {
        heading: "Access Time Pattern",
        accessor: "accessTimePatterns",
        searchOnName: "accessTimePattern.atpName",
        translationKey: "accessTimePattern"
    }
];

export default AccessGroupSearch;
